module.exports = __webpack_public_path__ + "img/D.6550f842.png";